"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomNumber = void 0;
/**
 * generate random digits (e.g. confirm email flow)
 *
 * @param n - the number of random digits
 * @returns a string with n random digits
 */
function randomNumber(n) {
    const add = 1;
    let max = 12 - add; // 12 is the min safe number Math.random() can generate without it starting to pad the end with zeros.
    if (n > max) {
        return randomNumber(max) + randomNumber(n - max);
    }
    max = 10 ** (n + add);
    const min = max / 10; // Math.pow(10, n) basically
    const number = Math.floor(Math.random() * (max - min + 1)) + min;
    return `${number}`.substring(add);
}
exports.randomNumber = randomNumber;
//# sourceMappingURL=randomNumber.js.map